var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnterprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: #323232;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.57px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.45,20.32c-1.06.44-2.23.68-3.45.68-4.97,0-9-4.03-9-9,0-.38.02-.75.07-1.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.46,7.09c1.61-2.46,4.38-4.09,7.54-4.09,4.97,0,9,4.03,9,9,0,2.27-.84,4.35-2.23,5.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.45,9.2c.51.81.81,1.77.81,2.8,0,2.9-2.35,5.26-5.26,5.26s-5.26-2.35-5.26-5.26,2.35-5.26,5.26-5.26c.5,0,.98.07,1.44.2"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12,
    cy: 12,
    r: 1.34
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12,
    cy: 12,
    r: 0.54
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprise);
export default __webpack_public_path__ + "static/media/Enterprise.996e764d4e784feaf3524259ab2d2a8b.svg";
export { ForwardRef as ReactComponent };